
import { mapState, mapGetters } from "vuex";
import Tabbar from "./components/Tabbar.vue";
import OfflineDiv from "./components/Offline.vue";
import Loading from 'vux/src/components/loading/index.vue'

import Icon from "./icons";
import $ from "jquery";
export default {
name: "App",
components: {
Loading,
Tabbar,
OfflineDiv
},
data() {
return {
islandscape: false
};
},
computed: mapState({
isLoading: state => state.loading.flag,
showTabbar: state => state.global.showTabbar,
showHeader: state => state.global.showHeader
}),
methods: {
orient() {


if (window.orientation == 0 || window.orientation == 180) {


this.islandscape = false;
return false;
} else if (window.orientation == 90 || window.orientation == -90) {


this.islandscape = true;
return false;
}
}
},
mounted() {
let _that = this;
_that.$options.methods.orient.bind(_that)();

$(window).bind("orientationchange", function(e) {
_that.$options.methods.orient.bind(_that)();
});
}
};



// WEBPACK FOOTER //
// ./src/app.vue